import { __exportAll } from "../_virtual/_rolldown/runtime.js";
import { BaseOrderedItemHelper } from "../helpers/base_ordered_item_helper.js";
import "../helpers/index.js";
import { getItemRefProperty, modIsVisibleInModGroup } from "../utils/mod_group_utils.js";
import "../utils/index.js";
import { ItemHiddenState } from "@biteinc/enums";
//#region src/services/quantity_validator.ts
var quantity_validator_exports = /* @__PURE__ */ __exportAll({
	fetchModelsAndValidate: () => fetchModelsAndValidate,
	getMaxAggregateQuantity: () => getMaxAggregateQuantity,
	getMaxSelectable: () => getMaxSelectable,
	getMinAggregateQuantity: () => getMinAggregateQuantity,
	getMinSelectable: () => getMinSelectable,
	isModGroupRequired: () => isModGroupRequired,
	menuItemOrModQuantityProps: () => menuItemOrModQuantityProps,
	modGroupQuantityProps: () => modGroupQuantityProps,
	validate: () => validate,
	validateQuantityOfItem: () => validateQuantityOfItem
});
const modGroupQuantityProps = [
	"_id",
	"minChoiceQuantity",
	"maxChoiceQuantity",
	"choiceQuantityIncrement",
	"allowMultipleOfSameAddon",
	"disableAllowMultipleOfSameAddon",
	"minSelectable",
	"posMinSelectableOverride",
	"maxSelectable",
	"posMaxSelectableOverride",
	"minAggregateQuantity",
	"posMinAggregateQuantityOverride",
	"maxAggregateQuantity",
	"posMaxAggregateQuantityOverride",
	"virtualSubGroups",
	"useAsComboBuilder",
	"items",
	"i9nItems"
];
const menuItemOrModQuantityProps = ["_id", "priceOptions"];
function validateQuantityOfMod(modGroupById, menuItemOrModById, modGroup, orderedMod, realQuantity) {
	const minChoiceQuantity = modGroup.minChoiceQuantity || 0;
	const maxChoiceQuantity = getItemRefProperty(modGroup, orderedMod._id, "maxChoiceQuantity", modGroup.maxChoiceQuantity || 1066);
	const choiceQuantityIncrement = modGroup.choiceQuantityIncrement || 1;
	const modErrors = [];
	if (realQuantity < minChoiceQuantity) modErrors.push({
		choiceQuantity: realQuantity,
		minChoiceQuantity
	});
	else if (maxChoiceQuantity < realQuantity) modErrors.push({
		choiceQuantity: realQuantity,
		maxChoiceQuantity
	});
	if (realQuantity % choiceQuantityIncrement !== 0) modErrors.push({
		choiceQuantity: realQuantity,
		choiceQuantityIncrement
	});
	const disallowMultipleOfSameMod = !modGroup.allowMultipleOfSameAddon || modGroup.disableAllowMultipleOfSameAddon;
	if (disallowMultipleOfSameMod && !orderedMod.substitutionFor) {
		if (1 < realQuantity) modErrors.push({
			choiceQuantity: realQuantity,
			allowMultipleOfSameMod: !disallowMultipleOfSameMod
		});
	}
	const modGroupErrors = [];
	orderedMod.priceOption.addonSets?.forEach((orderedModGroup) => {
		const modGroupError = validateQuantityOfModGroup(modGroupById, menuItemOrModById, orderedModGroup);
		if (modGroupError) modGroupErrors.push(modGroupError);
	});
	modGroupErrors.push(...validateItemOrModHasAllRequiredModGroups(modGroupById, menuItemOrModById, orderedMod));
	if (modErrors.length > 0 || modGroupErrors.length > 0) return {
		_id: orderedMod._id,
		orderedItemId: orderedMod.orderedItemId,
		...modGroupErrors.length && { priceOption: {
			_id: orderedMod.priceOption._id,
			addonSets: modGroupErrors
		} },
		errors: modErrors
	};
	return null;
}
function getMinSelectable(modGroup) {
	return Math.max(modGroup.minSelectable || 0, modGroup.posMinSelectableOverride || 0);
}
function getMaxSelectable(modGroup) {
	return Math.min(modGroup.maxSelectable || 1066, modGroup.posMaxSelectableOverride || 1066);
}
function getMinAggregateQuantity(modGroup) {
	return Math.max(modGroup.minAggregateQuantity || 0, modGroup.posMinAggregateQuantityOverride || 0);
}
function getMaxAggregateQuantity(modGroup) {
	return Math.min(modGroup.maxAggregateQuantity || 1066, modGroup.posMaxAggregateQuantityOverride || 1066);
}
function isModGroupRequired(modGroup) {
	return getMinSelectable(modGroup) > 0 || getMinAggregateQuantity(modGroup) > 0;
}
function hasSelectedItems(orderedModGroup) {
	return !!orderedModGroup.items?.some((orderedMod) => orderedMod.priceOption.quantity > 0);
}
function isSelectedComboBuilderModGroup(modGroupById, orderedModGroup) {
	return !!modGroupById[orderedModGroup._id.toString()]?.useAsComboBuilder && hasSelectedItems(orderedModGroup);
}
function isUnselectedComboBuilderModGroup(modGroupById, orderedModGroup) {
	return !!modGroupById[orderedModGroup._id.toString()]?.useAsComboBuilder && !hasSelectedItems(orderedModGroup);
}
function validateQuantityOfModGroup(modGroupById, menuItemOrModById, orderedModGroup) {
	const modGroup = modGroupById[orderedModGroup._id.toString()];
	if (!modGroup) return null;
	if (modGroup.useAsComboBuilder && !hasSelectedItems(orderedModGroup)) return null;
	const minSelectable = getMinSelectable(modGroup);
	const maxSelectable = getMaxSelectable(modGroup);
	const minAggregateQuantity = getMinAggregateQuantity(modGroup);
	const maxAggregateQuantity = getMaxAggregateQuantity(modGroup);
	const quantityByModId = /* @__PURE__ */ new Map();
	orderedModGroup.items?.forEach((orderedMod) => {
		const modId = orderedMod._id.toString();
		const quantity = orderedMod.priceOption.quantity;
		if (!quantityByModId.has(modId)) quantityByModId.set(modId, 0);
		quantityByModId.set(modId, quantityByModId.get(modId) + quantity);
	});
	const modGroupErrors = [];
	const uniqueModCount = quantityByModId.size;
	if (uniqueModCount < minSelectable) modGroupErrors.push({
		selected: uniqueModCount,
		minSelectable
	});
	else if (maxSelectable < uniqueModCount) modGroupErrors.push({
		selected: uniqueModCount,
		maxSelectable
	});
	const sumQuantity = Array.from(quantityByModId.values()).reduce((acc, quantity) => acc + quantity, 0);
	if (sumQuantity < minAggregateQuantity) modGroupErrors.push({
		aggregateQuantity: sumQuantity,
		minAggregateQuantity
	});
	else if (maxAggregateQuantity < sumQuantity) modGroupErrors.push({
		aggregateQuantity: sumQuantity,
		maxAggregateQuantity
	});
	const virtualSubGroupErrors = [];
	if (modGroup.virtualSubGroups) {
		const virtualSubGroupByModId = /* @__PURE__ */ new Map();
		modGroup.virtualSubGroups.forEach((virtualSubGroup) => {
			virtualSubGroup.items.forEach((mod) => {
				virtualSubGroupByModId.set(mod._id.toString(), virtualSubGroup);
			});
		});
		const isCombo = orderedModGroup.items?.some((orderedMod) => {
			return virtualSubGroupByModId.get(orderedMod._id.toString())?.useAsComboBuilder;
		});
		modGroup.virtualSubGroups.forEach((virtualSubGroup) => {
			const vsgModIds = new Set(virtualSubGroup.items.map((mod) => mod._id.toString()));
			const virtualSubGroupError = {
				_id: virtualSubGroup._id,
				errors: []
			};
			const vsgMinSelectable = virtualSubGroup.minSelectable || 0;
			const vsgMaxSelectable = virtualSubGroup.maxSelectable || 1066;
			const vsgMinAggregateQuantity = virtualSubGroup.minAggregateQuantity || 0;
			const vsgMaxAggregateQuantity = virtualSubGroup.maxAggregateQuantity || 1066;
			if (virtualSubGroup.items) {
				let vsgSelected = 0;
				let vsgAggregateQuantity = 0;
				virtualSubGroup.items.forEach((virtualSubGroupMod) => {
					const modIdStr = virtualSubGroupMod._id.toString();
					if (!quantityByModId.has(modIdStr)) return;
					++vsgSelected;
					vsgAggregateQuantity += quantityByModId.get(modIdStr);
				});
				if (vsgSelected === 0 && !isCombo && virtualSubGroup.useAsComboBuilder) return;
				if (vsgSelected < vsgMinSelectable) virtualSubGroupError.errors.push({
					selected: vsgSelected,
					minSelectable: vsgMinSelectable
				});
				else if (vsgMaxSelectable < vsgSelected) virtualSubGroupError.errors.push({
					selected: vsgSelected,
					maxSelectable: vsgMaxSelectable
				});
				if (vsgAggregateQuantity < vsgMinAggregateQuantity) virtualSubGroupError.errors.push({
					aggregateQuantity: vsgAggregateQuantity,
					minAggregateQuantity: vsgMinAggregateQuantity
				});
				else if (vsgMaxAggregateQuantity < vsgAggregateQuantity) virtualSubGroupError.errors.push({
					aggregateQuantity: vsgAggregateQuantity,
					maxAggregateQuantity: vsgMaxAggregateQuantity
				});
				const disallowMultipleOfSameMod = !(virtualSubGroup.allowMultipleOfSameAddon ?? modGroup.allowMultipleOfSameAddon) || modGroup.disableAllowMultipleOfSameAddon;
				const virtualSubGroupModErrors = [];
				if (disallowMultipleOfSameMod) orderedModGroup.items?.forEach((orderedMod) => {
					const orderedModIdStr = orderedMod._id.toString();
					if (!vsgModIds.has(orderedModIdStr)) return;
					if (orderedMod.substitutionFor) return;
					const realQuantity = quantityByModId.get(orderedModIdStr);
					if (1 < realQuantity) virtualSubGroupModErrors.push({
						_id: orderedMod._id,
						orderedItemId: orderedMod.orderedItemId,
						errors: [{
							choiceQuantity: realQuantity,
							allowMultipleOfSameMod: false
						}]
					});
				});
				if (virtualSubGroupModErrors.length) virtualSubGroupError.items = virtualSubGroupModErrors;
			}
			if (virtualSubGroupError.errors.length || virtualSubGroupError.items?.length) virtualSubGroupErrors.push(virtualSubGroupError);
		});
	}
	const modErrors = [];
	orderedModGroup.items?.forEach((orderedMod) => {
		const modError = validateQuantityOfMod(modGroupById, menuItemOrModById, modGroup, orderedMod, quantityByModId.get(orderedMod._id.toString()));
		if (modError) modErrors.push(modError);
	});
	if (modGroupErrors.length > 0 || modErrors.length > 0 || virtualSubGroupErrors.length > 0) return {
		_id: modGroup._id,
		...modErrors.length && { items: modErrors },
		...virtualSubGroupErrors.length && { virtualSubGroups: virtualSubGroupErrors },
		errors: modGroupErrors
	};
	return null;
}
/**
* If an item or mod has a mod group with a min-selectable or min-aggregate quantity of at least 1,
* then that mod group is considered required and must exist on the ordered item or mod.
*/
function validateItemOrModHasAllRequiredModGroups(modGroupById, menuItemOrModById, orderedItemOrMod) {
	const menuItem = menuItemOrModById[orderedItemOrMod._id.toString()];
	if (!menuItem) return [];
	const orderedModGroups = orderedItemOrMod.priceOption.addonSets ?? [];
	const isCombo = orderedModGroups.some((modGroupRef) => {
		return isSelectedComboBuilderModGroup(modGroupById, modGroupRef);
	});
	const orderedModGroupIds = /* @__PURE__ */ new Set();
	const modGroupErrors = [];
	orderedModGroups.forEach((modGroup) => {
		if (isCombo && isUnselectedComboBuilderModGroup(modGroupById, modGroup)) return;
		orderedModGroupIds.add(modGroup._id.toString());
	});
	menuItem.priceOptions.find((po) => po._id.toString() === orderedItemOrMod.priceOption._id.toString())?.addonSetIds?.forEach((modGroupId) => {
		if (orderedModGroupIds.has(modGroupId.toString())) return;
		const modGroup = modGroupById[modGroupId.toString()];
		if (!modGroup || modGroup.useAsComboBuilder && !isCombo) return;
		if (modGroup.items?.every((orderedMod) => {
			const mod = menuItemOrModById[orderedMod._id.toString()];
			if (!mod) return true;
			return !modIsVisibleInModGroup(modGroup, mod._id) || mod.priceOptions.every((modPO) => {
				return modPO.hiddenState === ItemHiddenState.HiddenIndefinitely || modPO.i9nHiddenState === ItemHiddenState.HiddenIndefinitely || modPO.hiddenState === ItemHiddenState.HiddenUntilTomorrow || modPO.i9nHiddenState === ItemHiddenState.HiddenUntilTomorrow;
			});
		})) return;
		const minSelectable = getMinSelectable(modGroup);
		const minAggregateQuantity = getMinAggregateQuantity(modGroup);
		if (minSelectable > 0) modGroupErrors.push({
			_id: modGroup._id,
			errors: [{
				selected: 0,
				minSelectable
			}]
		});
		if (minAggregateQuantity > 0) modGroupErrors.push({
			_id: modGroup._id,
			errors: [{
				aggregateQuantity: 0,
				minAggregateQuantity
			}]
		});
	});
	return modGroupErrors;
}
function validateQuantityOfItem(modGroupById, menuItemOrModById, orderedItemOrMod) {
	const modGroupErrors = [];
	orderedItemOrMod.priceOption.addonSets?.forEach((modGroup) => {
		const modGroupError = validateQuantityOfModGroup(modGroupById, menuItemOrModById, modGroup);
		if (modGroupError) modGroupErrors.push(modGroupError);
	});
	modGroupErrors.push(...validateItemOrModHasAllRequiredModGroups(modGroupById, menuItemOrModById, orderedItemOrMod));
	if (modGroupErrors.length > 0) return {
		_id: orderedItemOrMod._id,
		orderedItemId: orderedItemOrMod.orderedItemId,
		priceOption: {
			_id: orderedItemOrMod.priceOption._id,
			addonSets: modGroupErrors
		}
	};
	return null;
}
async function fetchModelsAndValidate(modelFactory, orderedItems) {
	const MenuItem = modelFactory.getMenuItemClass();
	const ModGroup = modelFactory.getModGroupClass();
	const menuItemIds = BaseOrderedItemHelper.getAllItemIdsForOrderedItems(orderedItems, false);
	const modIds = BaseOrderedItemHelper.getAllModIds(orderedItems);
	const menuItemsAndMods = await MenuItem.findProjectedData({ _id: { $in: [...menuItemIds, ...modIds] } }, menuItemOrModQuantityProps);
	const modGroupIds = BaseOrderedItemHelper.getAllModGroupIds(orderedItems).concat(menuItemsAndMods.flatMap((menuItemOrMod) => menuItemOrMod.priceOptions.filter((priceOption) => !!priceOption.addonSetIds?.length || !!priceOption.floatingModGroupIds?.length).flatMap((priceOption) => [...priceOption.addonSetIds ?? [], ...priceOption.floatingModGroupIds ?? []])));
	const modGroups = await ModGroup.findProjectedData({ _id: { $in: modGroupIds } }, modGroupQuantityProps);
	const fetchedOrWillBeFetchedModIdsSet = new Set(modIds.map((id) => id.toString()));
	const modIdsToFetch = [];
	modGroups.forEach((modGroup) => {
		modGroup.items.forEach((mod) => {
			const modIdStr = mod._id.toString();
			if (fetchedOrWillBeFetchedModIdsSet.has(modIdStr)) return;
			fetchedOrWillBeFetchedModIdsSet.add(modIdStr);
			modIdsToFetch.push(mod._id);
		});
	});
	const mods = modIdsToFetch.length ? await MenuItem.findProjectedData({ _id: { $in: modIdsToFetch } }, menuItemOrModQuantityProps) : [];
	return validate(orderedItems, modGroups, [...menuItemsAndMods, ...mods]);
}
function validate(orderedItems, modGroups, menuItemAndMods) {
	const modGroupById = modGroups.reduce((acc, modGroup) => {
		acc[modGroup._id.toString()] = modGroup;
		return acc;
	}, {});
	const menuItemOrModById = menuItemAndMods.reduce((acc, menuItemOrMod) => {
		acc[menuItemOrMod._id.toString()] = menuItemOrMod;
		return acc;
	}, {});
	const orderedItemErrors = [];
	orderedItems.forEach((orderedItem) => {
		const menuItemError = validateQuantityOfItem(modGroupById, menuItemOrModById, orderedItem);
		if (menuItemError) orderedItemErrors.push(menuItemError);
	});
	if (orderedItemErrors.length > 0) return { orderedItems: orderedItemErrors };
	return null;
}
//#endregion
export { fetchModelsAndValidate, getMaxAggregateQuantity, getMaxSelectable, getMinAggregateQuantity, getMinSelectable, isModGroupRequired, menuItemOrModQuantityProps, modGroupQuantityProps, quantity_validator_exports, validate, validateQuantityOfItem };

//# sourceMappingURL=quantity_validator.js.map